// @ts-strict-ignore
import {Component, Input, OnChanges, OnInit, SimpleChanges, output} from "@angular/core";
import {CameraLayoutOption, HorizontalLayoutOption, VerticalLayoutOption} from "@models";
import {CameraLayoutOptionsContainer} from "../../../../types/camera-layout-options";
import {BaseRecorderLayout} from "../base-recorder-layout";

@Component({
	selector: "sim-recorder-layout-pip",
	templateUrl: "./recorder-layout-pip.component.html",
	styleUrls: ["./recorder-layout-pip.component.scss"],
	standalone: false,
})
export class RecorderLayoutPipComponent extends BaseRecorderLayout implements OnInit, OnChanges {
	@Input() cameraLayoutOptionsContainer: CameraLayoutOptionsContainer;
	@Input() cameraLayoutOptionsContainerNew: CameraLayoutOption;

	@Input() isPipEditable = false;
	pipLayoutOptionsChanged = output<CameraLayoutOption>();

	public pictureInPicturePosition: "TopLeft" | "TopRight" | "BottomLeft" | "BottomRight" = "TopLeft";
	public cssClassesForOverlayPicture: string;

	big = false;

	constructor() {
		super();
	}

	ngOnInit() {
		this.initializeCameraLayout();
	}

	public setPipVideoPosition(position: "top" | "left" | "right" | "bottom") {
		if (!this.cameraLayoutOptionsContainerNew) {
			this.cameraLayoutOptionsContainerNew = {
				...this.cameraLayoutOptionsContainer.options.cameraLayoutOption,
			};
		}

		switch (position) {
			case "top":
				this.cameraLayoutOptionsContainerNew.verticalLayout = VerticalLayoutOption.Top;
				break;
			case "bottom":
				this.cameraLayoutOptionsContainerNew.verticalLayout = VerticalLayoutOption.Bottom;
				break;
			case "left":
				this.cameraLayoutOptionsContainerNew.horizontalLayout = HorizontalLayoutOption.Left;
				break;
			case "right":
				this.cameraLayoutOptionsContainerNew.horizontalLayout = HorizontalLayoutOption.Right;
				break;
		}

		this.initializeCameraLayout(this.cameraLayoutOptionsContainerNew);
		this.pipLayoutOptionsChanged.emit(this.cameraLayoutOptionsContainerNew);
	}

	private initializeCameraLayout(cameraLayoutOptionChanged?: CameraLayoutOption) {
		let cameraLayoutOption = cameraLayoutOptionChanged
			? cameraLayoutOptionChanged
			: this.cameraLayoutOptionsContainer.options.cameraLayoutOption;

		if (cameraLayoutOption) {
			if (cameraLayoutOption.horizontalLayout === HorizontalLayoutOption.Left) {
				if (cameraLayoutOption.verticalLayout === VerticalLayoutOption.Top) {
					this.pictureInPicturePosition = "TopLeft";
				} else if (cameraLayoutOption.verticalLayout === VerticalLayoutOption.Bottom) {
					this.pictureInPicturePosition = "BottomLeft";
				}
			} else if (cameraLayoutOption.horizontalLayout === HorizontalLayoutOption.Right) {
				if (cameraLayoutOption.verticalLayout === VerticalLayoutOption.Top) {
					this.pictureInPicturePosition = "TopRight";
				} else if (cameraLayoutOption.verticalLayout === VerticalLayoutOption.Bottom) {
					this.pictureInPicturePosition = "BottomRight";
				}
			}
		} else {
			this.cameraLayoutOptionsContainer.options.cameraLayoutOption = {
				horizontalLayout: HorizontalLayoutOption.Left,
				verticalLayout: VerticalLayoutOption.Top,
			};
			this.pictureInPicturePosition = "TopLeft";
		}

		this.cssClassesForOverlayPicture = "col-xs-4 col-md-4 col-lg-4 VID_Overlay " + this.pictureInPicturePosition;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["cameraLayoutOptionsContainer"]) {
			this.initializeCameraLayout();
			this.cameraLayoutOptionsContainerNew = null;
		}
	}
}
